import { useEffect, useState } from "react";

interface ExpandableDateProps {
  date: Date | string;
}

export function ExpandableDate({ date }: ExpandableDateProps) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const [isExpanded, setIsExpanded] = useState(false);
  const dateObj = date instanceof Date ? date : new Date(date);

  const shortFormat = isClient
    ? dateObj.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "";

  const fullFormat = isClient
    ? dateObj.toLocaleString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZoneName: "short",
      })
    : "";

  return (
    <span onClick={() => setIsExpanded(!isExpanded)}>
      {isExpanded ? fullFormat : `${shortFormat}...`}
    </span>
  );
}

export function longDateFormat(dateString: string): string {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [year, month, day] = dateString.split("-");
  if (!year || !month || !day) return "Invalid date";

  const monthIndex = parseInt(month, 10) - 1; // Convert to 0-based index.
  if (monthIndex < 0 || monthIndex > 11) return "Invalid month";

  const dayNumber = parseInt(day, 10); // Remove leading zero.
  if (dayNumber < 0 || dayNumber > 31) return "Invalid day";

  return `${months[monthIndex]} ${dayNumber}, ${year}`;
}
